import { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import styled from "styled-components";

import Input from "../../ui-kit/input";
import { Button, Textarea } from "../../ui-kit/styled-templates";

export default function ArticleForm(props) {
    const { t } = useTranslation();
    const { loading = false, onSave = (d) => {}, canDelete = false, onDelete = () => {} } = props;

    const [name, setName] = useState(props.name || "");
    const [html, setHtml] = useState(props.html || "");
    const [description, setDescription] = useState(props.description || "");

    return (
        <Wrapper>
            <Row>
                <Label>{t("1nwyasrbvp5")}</Label>
                <Input
                    value={name}
                    onChange={(e) => {
                        setName(e.target.value);
                    }}
                />
            </Row>

            <Row>
                <Label>{t("it2kmvdzkji")}</Label>
                <Textarea
                    value={description}
                    onChange={(e) => {
                        setDescription(e.target.value);
                    }}
                />
            </Row>

            <Row>
                <Label>{t("3qoqlbt3q9l")}</Label>
                <ReactQuill value={html} onChange={setHtml} />
            </Row>

            <BottomPlaceholder>
                <Button
                    onClick={() => {
                        onSave({
                            name,
                            description,
                            html,
                        });
                    }}
                >
                    {loading == true ? "..." : null}
                    {loading == true ? null : t("9r16a9dxhqj")}
                </Button>
            </BottomPlaceholder>

            {canDelete == false ? null : (
                <div style={{ marginTop: 10, color: "red" }}>
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            onDelete();
                        }}
                    >
                        {t("3hb6fbdhgyi")}
                    </span>
                </div>
            )}
        </Wrapper>
    );
}

const Wrapper = styled.div``;

const BottomPlaceholder = styled.div``;

const Row = styled.div`
    margin-bottom: 20px;
`;

const Label = styled.div`
    font-weight: bold;
    margin-bottom: 5px;
`;
